<div class="general-container">
  <h2 class="font-sans text-h400 md:text-h600 text-eggplant-100/[0.25]">{{ 'overview.about' | translate }}</h2>
  <div>
      <div class="text-container">
          <section class="[&>p]:text-eggplant-100 [&>p]:pb-12 [&>p]:text-l md:[&>p]:text-xl lg:[&>p]:text-h400 [&>p]:font-sans [&>h3]:font-sans
            [&>h3]:text-eggplant-100 [&>ul]:list-disc [&>ul]:pl-[22px] [&>h3]:pb-12 [&>h3]:text-2xl md:[&>h3]:text-h500
            [&>ul>li]:text-l md:[&>ul>li]:text-xl lg:[&>ul>li]:text-h400 [&>ul>li]:pb-12 [&>ul>li]:font-sans [&>ul>li]:text-eggplant-100 opened" innerHTML="{{ text }}">
          </section>
      </div>
  </div>

  <h2 *ngIf="imageUrl !== null && imageUrl !== undefined" class="font-sans text-h400 md:text-h600 text-eggplant-100/[0.25] pb-40">{{ 'OVERVIEW_PROJECT.IMG' | translate }}</h2>
  <div *ngIf="imageUrl !== null && imageUrl !== undefined" class="relative overflow-hidden">
    <ion-slides pager="true" #sliderImg (ionSlideDidChange)="getCurrentItem()" [options]="slideOpts">
        <div class="swiper-slide" *ngIf="aboutProjectInfo.id === 41">
          <app-youtube-video-player #videoPlayer></app-youtube-video-player>
        </div>
        <ion-slide *ngFor="let image of imageUrl">
            <div class="image-container" [ngStyle]="{'background':' url(' + image + ')', 'background-size': 'cover', 'background-position': 'center'}"></div>
        </ion-slide>
    </ion-slides>
    <div *ngIf="(imageUrl.length > 1)" class="w-34 h-34 md:w-96 md:h-96 arrow arrow-left" (click)="prev()" [ngClass]="{'arrow-disabled': sliderIndex === 0 }">
      <fun-icon [name]="'arrow-left'" [style]="'w-24 h-24 md:w-64 md:h-64 stroke-2 stroke-white'"></fun-icon>
    </div>
    <div *ngIf="(imageUrl.length > 1)" class="w-34 h-34 md:w-96 md:h-96 arrow arrow-right" (click)="next()" [ngClass]="{'arrow-disabled': sliderIndex === imageUrl.length - 1 }">
      <fun-icon [name]="'arrow-right'" [style]="'w-24 h-24 md:w-64 md:h-64 stroke-2 stroke-white'"></fun-icon>
    </div>
  </div>

</div>
